<div
    role="group"
    class="agpr-titleStyleField agpr-formField agpr-titleStyleField-container"
    [attr.aria-label]="'Briefing.textStyle.title.label' | localize"
>

    <div class="agpr-formField-heading">
        <label class="agpr-formField-headingLabel">{{ 'Briefing.textStyle.title.label' | localize }}</label>
        <div class="agpr-formField-headingButtons">
            @if (field.allowExpertMode) {
                <agpr-button
                    class="agpr-formField-headingButton"
                    [style]="buttonTypes.icon"
                    icon="fa-regular fa-duotone fa-code"
                    tooltip="PageBuilder.formField.tooltip.expertTemplateEditor"
                    tooltipPosition="top"
                    (click)="saveExpertTemplate()"
                ></agpr-button>
            }
            <agpr-button
                class="agpr-formField-headingButton"
                [style]="buttonTypes.icon"
                icon="fa-regular fa-duotone fa-floppy-disk"
                tooltip="PageBuilder.formField.tooltip.saveStyle"
                tooltipPosition="top"
                (click)="saveStyle()"
            ></agpr-button>
        </div>
    </div>

    <div class="agpr-titleStyleField-styleState">
        <div class="agpr-inputGroupRow">
            <div class="agpr-inputGroupRow-dropdown">
                <agpr-dropdown-field
                    [id]="id + '_styleStateDropdown'"
                    [value]="value.displayStyleState"
                    [field]="styleStateField"
                    [updateOptions]="styleStateField.options"
                    (changes)="setStyle($event, styleStateField.property)"
                ></agpr-dropdown-field>
            </div>
            <div class="agpr-inputGroupRow-buttons">
                <agpr-button
                    [id]="id + '_manageStyles'"
                    [style]="buttonTypes.block"
                    icon="fa-regular fa-duotone fa-gear"
                    tooltip="PageBuilder.formField.tooltip.manageStyles"
                    (click)="manageStylesButtonClicked()"
                ></agpr-button>
            </div>
        </div>
    </div>

    @if (!value.template) {
        <div class="agpr-titleStyleField-headingSection">
            <agpr-briefing-text-style-field
                [id]="id + '_heading_1'"
                [field]="field"
                [value]="value"
                [smallLabel]="true"
                [blockPaddingHeaderClass]="'agpr-block-padding-header--topSpaced'"
                (changes)="setStyle($event, null)"
            ></agpr-briefing-text-style-field>
        </div>

        <div class="agpr-titleStyleField-headingSection">
            <agpr-briefing-text-style-field
                [id]="id + '_heading_2'"
                [field]="headingTwoField"
                [value]="headingTwo"
                [smallLabel]="true"
                [blockPaddingHeaderClass]="'agpr-block-padding-header--topSpaced'"
                (changes)="setStyle($event, headingTwoField.property)"
            ></agpr-briefing-text-style-field>
        </div>

        <div class="agpr-titleStyleField-headingSection">
            <agpr-briefing-text-style-field
                [id]="id + '_heading_3'"
                [field]="headingThreeField"
                [value]="headingThree"
                [smallLabel]="true"
                [blockPaddingHeaderClass]="'agpr-block-padding-header--topSpaced'"
                [blockPaddingLabelSemibold]="true"
                (changes)="setStyle($event, headingThreeField.property)"
            ></agpr-briefing-text-style-field>
        </div>
    } @else {
        <div class="agpr-titleStyleField-expertApplied">
            <agpr-message [severity]="messageSeverityEnum.info">
                {{ "PageBuilder.styles.expertStyleAppliedPreMessage" | localize }}
                <span style="font-weight: bold">
                    {{ 'Briefing.textStyle.title.label' | localize }}
                </span>
                {{ "PageBuilder.styles.expertStyleAppliedPostMessage" | localize }}
            </agpr-message>
        </div>
    }
</div>
